import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import ServicesSection from "../components/ServicesSection";
import GirneCatalogSection from "../components/GirneCatalogSection";
import WhyChooseUsSection from "../components/WhyChooseUsSection";
import AboutSection from "../components/AboutSection";
import GallerySection from "../components/GallerySection";
import MediaGallerySection from "../components/MediaGallerySection";
import TestimonialsSection from "../components/TestimonialsSection";
import FAQSection from "../components/FAQSection";
import ContactSection from "../components/ContactSection";
import Footer from "../components/Footer";
import FloatingWhatsApp from "../components/FloatingWhatsApp";
import StickyMobileCTA from "../components/StickyMobileCTA";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#050505] overflow-x-hidden" data-testid="landing-page">
      <Navbar />
      <main>
        {/* Hero - Primary conversion with urgency */}
        <HeroSection />
        
        {/* Services - Konsomatris, Dansöz, VIP Transfer */}
        <ServicesSection />
        
        {/* Venue - First Lady Club, Direk Dansı, Striptiz */}
        <GirneCatalogSection />
        
        {/* Why Choose Us - Trust & differentiation */}
        <WhyChooseUsSection />
        
        {/* About - Company story & credibility */}
        <AboutSection />
        
        {/* Gallery - Visual proof */}
        <GallerySection />
        
        {/* Media Gallery - Custom Videos & Photos */}
        <MediaGallerySection />
        
        {/* Testimonials - Social proof */}
        <TestimonialsSection />
        
        {/* FAQ - SEO + Trust */}
        <FAQSection />
        
        {/* Contact - Final conversion */}
        <ContactSection />
      </main>
      <Footer />
      
      {/* Floating CTAs */}
      <FloatingWhatsApp />
      <StickyMobileCTA />
    </div>
  );
};

export default LandingPage;
